import { render, staticRenderFns } from "./BookStockSummary.vue?vue&type=template&id=54c15e88"
import script from "./BookStockSummary.vue?vue&type=script&lang=js"
export * from "./BookStockSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports